module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0007-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS BOOK WOULD NOT EXIST NOT FOR THE")]), _vm._v(" generous assistance of hundreds of men and women who understood the need to tell the story of SOG and its remarkable warriors. They include everyone from families of lost SOG men to former Chiefs SOG, from young Green Berets to general officers, from fighter pilots to helicopter doorgunners—their irreplaceable pictures became the stunning mosaic captured in these pages. Each contributor’s name is cited beside his photos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some people lent considerable time and resources to help this project, particularly the Special Operations Association’s archivist, Steve Sherman, who helped identify men and piece together events of 30 years ago. Professor Richard Shultz of the Fletcher School of Law and Diplomacy shared his extensive library of declassified SOG documents. Robert Fisch, weapons curator at the West Point Military Museum, along with Z. Frank Hanner, director of the National Infantry Museum at Ft. Benning, Georgia, and Roxanne Merritt, director of Ft. Bragg’s JFK Special Warfare Museum, contributed pictures and valuable information. Author Shelby Stanton provided liberal access to his collection of Special Forces wartime photographs. Veteran Huey pilots Mike Sloniker and Fred Norris went all out to find helicopter photos and aircrew and unit identities. Lee Hess, president of the “Stray Goose” Blackbird crewmen’s association, gathered outstanding pictures from among his MC-130 veterans. Complete photo collections were loaned or even donated by Eldon Bargewell, Dale Boswell, Frank Greco, Mary Ann Harrison, Richard Jalloway, George Gaspard, Eugene McCarley, and Ted Wicorek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All these photographs and slides were processed by a crew of excellent photo technicians, including Douglas Black, Roger Kennedy, Charles Farrow, and Holly Hatch. The superb maps were designed by graphic artist Joy Benson, while original art flowed from the pen of Tami Odegard.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0a33c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 75
// module chunks = 0